import { createApp } from 'vue';
import OtfToWoffConverter from '@/Components/OtfToWoffConverter.vue';
import '@styles/app.css';

createApp(OtfToWoffConverter).mount('#otf-to-woff-converter');
